var _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightCornerAccent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 113,
    viewBox: "0 0 116 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2188 0.0605469L76.3778 0.120652C76.3446 21.1953 59.2333 38.2528 38.1586 38.2196L38.2188 0.0605469Z",
    fill: "#69CD92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1587 38.2191L38.2188 0.0601292C17.1442 0.0269342 0.032869 17.0844 -0.000326077 38.159L38.1587 38.2191Z",
    fill: "#FFED29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9219 76.1255L79.3901 112.527C99.4943 112.269 115.582 95.7616 115.324 75.6573L78.9219 76.1255Z",
    fill: "#3A70F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.324 75.6573L78.9218 76.1255C78.6632 56.0213 94.7513 39.514 114.856 39.2554L115.324 75.6573Z",
    fill: "#FFED29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2025,
    cy: 18.2025,
    r: 18.2025,
    transform: "matrix(0.999917 -0.0128605 -0.0128605 -0.999917 78.4683 37.8701)",
    fill: "#3A70F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCornerAccent);
export default __webpack_public_path__ + "static/media/right-corner-accent.f30073cdbe8770439e937fddc5c21e6d.svg";
export { ForwardRef as ReactComponent };